module.exports = __webpack_public_path__ + "static/media/expand.bc2dbe2b.svg";